import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useStore } from "shared/hooks";
import { CompanyBestGroupModel } from "shared/models";
import { companyBestGroupsQuery } from "shared/queries";
import { UiAvatar, UiDataBoundary, UiGrid, UiNavLink } from "shared/uikit";
import { ROUTES } from "shared/constants";

import './styles.scss';

export const PCompanyBestGroups = observer(() => {
    const store = useStore(() => ({
        isLoading: false,
        isSuccess: false,
        items: [] as CompanyBestGroupModel[]
    }));

    useEffect(() => {
        (async () => {
            store.set('isLoading', true);
            const { isSuccess, data } = await companyBestGroupsQuery();
            if (isSuccess && data) {
                store.set("items", data.items.map(item => new CompanyBestGroupModel(item)));
            }
            store.set("isSuccess", isSuccess && data);
            store.set('isLoading', false);
        })();
    }, [store]);

    return (
        <div className="p-company-best">
            <UiDataBoundary isLoading={store.isLoading} isError={!store.isSuccess}>
                <div className="p-company-best__title">Лучшие сотрудники месяца</div>
                {store.items.map(item => (
                    <div key={item.id} className="p-company-best-group">
                        <div className="p-company-best-group__name">{item.name}</div>
                        <UiGrid columns={2} gap={16}>
                            {item.users.map(user => (
                                <UiNavLink
                                    key={user.id}
                                    to={ROUTES.USER(user.slug)}
                                    className="p-company-best-group-user"
                                >
                                    <div className="p-company-best-group-user__avatar">
                                        <UiAvatar size={40} label={user.previewName} image={user.imageAvatar}/>
                                    </div>
                                    <div className="p-company-best-group-user__name">
                                        {user.previewName}
                                    </div>
                                </UiNavLink>
                            ))}
                        </UiGrid>
                    </div>
                ))}
            </UiDataBoundary>
        </div>
    );
})

